/* eslint-disable */

import React from 'react';
import styled from 'styled-components';
import { Progress } from 'semantic-ui-react';

const ProgressContainer = styled.div`
  width: 400px;
  padding-top: 140px;
  margin: 0 auto;
`;

const AdPreviewLoader = (props) => {
  const _percent =
    (parseInt(props.loaderCount) * 100) / parseInt(props.loaderTotal);
  return (
    <ProgressContainer>
      <Progress
        percent={_percent}
        color={props.color || 'green'}
        size={props.size || 'tiny'}
        active
      >
        <span>{`${props.loaderCount}/${props.loaderTotal}`}</span>
        <br />
        Loading...
      </Progress>
    </ProgressContainer>
  );
};

export default AdPreviewLoader;



// WEBPACK FOOTER //
// ./src/components/common/AdPreviewLoader.js